import * as React from "react";
import { Table, Row, Col } from "reactstrap";
import { accentUtils, format, showDialog, showOK, t } from "../../services/HelperService";
import { getAccess, getUser } from "../../services/UserService";
import { AccentButton } from "../AccentButton";
import { AccentDialog } from "../../dialogs/AccentDialog";
import AccentIcons from "../../icons/Icons";



var diffType = {
    Line: "diff_type_line",
    Configuration: "diff_type_configuration",
    Margin: "diff_type_margin",
    SalePice: "diff_type_sale_price",
    LineAdded: "diff_type_line_added",
    LineRemoved: "diff_type_line_removed"
};



export class JobDiffCtrl extends React.Component {

    constructor(props) {
        super(props);

        this.quoted = this.props.quoted;
        this.diff = this.props.diff;
        this.showDetails = this.showDetails.bind(this);
    }


    showDetails(line) {


        showOK("application_strings.views.jobDiff.details", <JobDiffDetailDlg diff={line} userModel={getUser()} />, ["application_strings.application.buttons.ok"], false, null, true).then(function (res) {

        });

    }

    render() {

        if (accentUtils.isNull(this.diff)) {
            return <label>{t("application_strings.views.jobDiff.noChanges")}</label>;
        }

        const userAllowCost = getAccess().features().FeatureAllowViewCostPrice();

        var me = this;

        var salePriceClass = (this.diff.NewSalePrice - this.diff.OriginalSalePrice > 0) ? "accentNumCol diff-warn" : "accentNumCol diff-ok";
        var marginClass = (this.diff.NewMargin - this.diff.OriginalMargin < 0) ? "accentNumCol diff-warn" : "accentNumCol diff-ok";



        var lines = this.diff.Lines.filter(l => l.Items.length > 0).map(function (l) {

            var salePriceIndicator = <span className={(l.SalePriceChange > 0 ? "accentUp diff-warn" : l.SalePriceChange < 0 ? "accentDown diff-warn" : undefined)} />;
            var marginIndicator = <span className={(l.MarginChange > 0 ? "accentUp diff-warn" : l.MarginChange < 0 ? "accentDown diff-warn" : undefined)} />;

            return <tr key={l.ID}>
                <td>{l.LineNo}</td>
                <td>{l.Location}</td>
                <td>{l.Supplier}</td>
                <td>{l.Product}</td>
                <td className="accentNumCol">{format.formatCurrency(l.SalePriceInc)}{salePriceIndicator}</td>
                <td className="accentNumCol">{userAllowCost ? format.formatPercentage(l.Margin) : ""}{marginIndicator}</td>
                <td className="accentNumCol"><AccentButton tagName={"changeDetailBtn_" + l.ID} onClick={function () { me.showDetails(l); }}>...</AccentButton></td>
            </tr>;

        });


        var removed = this.diff.RemovedLines.map(function (l) {

            var salePriceIndicator = <span className={(l.SalePriceChange > 0 ? "accentUp diff-warn" : l.SalePriceChange < 0 ? "accentDown diff-warn" : undefined)} />;
            var marginIndicator = <span className={(l.MarginChange > 0 ? "accentUp diff-warn" : l.MarginChange < 0 ? "accentDown diff-warn" : undefined)} />;

            return <tr key={l.ID} className="diff-removed">
                <td>{l.LineNo}</td>
                <td>{l.Location}</td>
                <td>{l.Supplier}</td>
                <td>{l.Product}</td>
                <td className="accentNumCol">{format.formatCurrency(l.SalePriceInc)}{salePriceIndicator}</td>
                <td className="accentNumCol">{userAllowCost ? format.formatPercentage(l.Margin) : ""}{marginIndicator}</td>
                <td className="accentNumCol"><AccentButton tagName={"changeDetailBtn_" + l.ID} onClick={function () { me.showDetails(l); }}>...</AccentButton></td>
            </tr>;

        });

        var noChanges = lines.length === 0 && removed.length === 0;

        return <Col md="12">
            <Row>
                <Col md="12">
                    <Table className="table-sm">
                        <thead>
                            <tr>
                                <th>{t("application_strings.views.jobDiff.jobDetails")}</th>
                                <th className="accentNumCol">{t("application_strings.views.jobDiff.originalValue")}</th>
                                <th className="accentNumCol">{t("application_strings.views.jobDiff.newValue")}</th>
                                <th className="accentNumCol">{t("application_strings.views.jobDiff.change")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{t("application_strings.views.jobDiff.salePriceInc")}</td>
                                <td className="accentNumCol">{format.formatCurrency(this.diff.OriginalSalePrice)}</td>
                                <td className="accentNumCol">{format.formatCurrency(this.diff.NewSalePrice)}</td>
                                <td className={salePriceClass}>{format.formatCurrency(this.diff.NewSalePrice - this.diff.OriginalSalePrice)}</td>
                            </tr>
                            {!userAllowCost ? null :
                                <tr>
                                    <td>{t("application_strings.views.jobDiff.margin")}</td>
                                    <td className="accentNumCol">{format.formatPercentage(this.diff.OriginalMargin)}</td>
                                    <td className="accentNumCol">{format.formatPercentage(this.diff.NewMargin)}</td>
                                    <td className={marginClass}>{format.formatPercentage(this.diff.NewMargin - this.diff.OriginalMargin)}</td>
                                </tr>
                            }
                        </tbody>
                    </Table>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <Table className="table-sm">
                        <tbody>
                            <tr>
                                <th>{t("application_strings.views.jobDiff.lineNo")}</th>
                                <th>{t("application_strings.views.jobDiff.location")}</th>
                                <th>{t("application_strings.views.jobDiff.supplier")}</th>
                                <th>{t("application_strings.views.jobDiff.product")}</th>
                                <th className="accentNumCol">{t("application_strings.views.jobDiff.salePriceInc")}</th>
                                <th className="accentNumCol">{t("application_strings.views.jobDiff.margin")}</th>
                                <th>{t("application_strings.views.jobDiff.details")}</th>
                            </tr>
                            {lines}
                            {removed}
                            {noChanges ? <td colSpan="7"><label>No changes found</label></td> : null}
                        </tbody>
                    </Table>
                </Col>
            </Row>

        </Col>;
    }
}




export class JobDiffDetailDlg extends React.Component {

    constructor(props) {
        super(props);

        this.diff = this.props.diff;
    }

    render() {
        const userAllowCost = getAccess().features().FeatureAllowViewCostPrice();

        var index = 0;
        var changes = this.diff.Items.length == 0 ? <tr key={index++}>
            <td colSpan="3"><label>No changes found</label></td>
        </tr> :
            this.diff.Items.filter(i => !i.IsCostItem || userAllowCost).map(function (i) {

                var originalValue = null;
                var newValue = null;

                if (i.IsCurrency) {
                    originalValue = format.formatCurrency(i.OriginalValue);
                    newValue = format.formatCurrency(i.NewValue);
                } else if (i.Type === diffType.Margin) {
                    originalValue = format.formatPercentage(i.OriginalValue);
                    newValue = format.formatPercentage(i.NewValue);
                } else {
                    try {
                        originalValue = decodeURIComponent(i.OriginalValue);
                    } catch (e) {
                        originalValue = i.OriginalValue;
                    }
                    const origLines = originalValue.split('\n');
                    var divs = origLines.filter(f => !f.startsWith("@@")).map(function (l) {
                        return <div>{l}</div>
                    });
                    originalValue = <div>{divs}</div>;
                    try {
                        newValue = (decodeURIComponent(i.NewValue));
                    } catch (e) {
                        newValue = i.NewValue;
                    }
                    const newLines = newValue.split('\n');
                    var newDivs = newLines.filter(f => !f.startsWith("@@")).map(function (l) {
                        return <div>{l}</div>
                    });
                    newValue = <div>{newDivs}</div>;
                }


                var fieldName = t("application_strings.views.jobDiff." + i.FieldName);

                if (fieldName.includes("application_strings")) {
                    fieldName = t("application_strings.entities.jobLine." + i.FieldName);
                }

                if (fieldName.includes("application_strings")) {
                    fieldName = i.FieldName;
                }


                return <tr key={index++}>
                    <td>{fieldName}</td>
                    <td className="accentNumCol">{originalValue}</td>
                    <td className="accentNumCol">{newValue}</td>
                </tr>;
            });


        return <Col md="12">
            <Row>
                <Col md="3"><label>{t("application_strings.views.jobDiff.lineNo")}</label></Col>
                <Col md="3">{this.diff.LineNo}</Col>
                <Col md="3"><label>{t("application_strings.views.jobDiff.location")}</label></Col>
                <Col md="3">{this.diff.Location}</Col>
            </Row>
            <Row>
                <Col md="3"><label>{t("application_strings.views.jobDiff.supplier")}</label></Col>
                <Col md="3">{this.diff.Supplier}</Col>
                <Col md="3"><label>{t("application_strings.views.jobDiff.product")}</label></Col>
                <Col md="3">{this.diff.Product}</Col>
            </Row>
            <Table className="table-sm">
                <tbody>
                    <tr>
                        <th>{t("application_strings.views.jobDiff.property")}</th>
                        <th className="accentNumCol">{t("application_strings.views.jobDiff.originalValue")}</th>
                        <th className="accentNumCol">{t("application_strings.views.jobDiff.newValue")}</th>
                    </tr>
                    {changes}
                </tbody>
            </Table>
        </Col>;

    }
}

export const ProductDiffs = ({ diffs }) => {
    const userAllowCost = getAccess().features().FeatureAllowViewCostPrice();
    
    // Get unique line numbers
    const lineNumbers = [...new Set(diffs.map(d => d.LineNo))].sort();
    
    // Get all unique properties across all diffs
    const allProperties = [...new Set(diffs.flatMap(d => 
        d.Items.filter(i => !i.IsCostItem || userAllowCost)
            .map(i => i.FieldName)
    ))];

    const renderValue = (value, isCurrency, type) => {
        if (isCurrency) {
            return format.formatCurrency(value);
        } else if (type === diffType.Margin) {
            return format.formatPercentage(value);
        } else {
            const decoded = decodeURIComponent(value);
            const lines = decoded.split('\n');
            return <div>{lines.filter(f => !f.startsWith("@@")).map((l, i) => <div key={i}>{l}</div>)}</div>;
        }
    };

    const getFieldName = (fieldName) => {
        let name = t("application_strings.views.jobDiff." + fieldName);
        if (name.includes("application_strings")) {
            name = t("application_strings.entities.jobLine." + fieldName);
        }
        if (name.includes("application_strings")) {
            name = fieldName;
        }
        return name;
    };

    return (
        <Col md="12">
            <Table className="table-sm">
                <thead>
                    <tr>
                        <th>{t("application_strings.views.jobDiff.property")}</th>
                        {lineNumbers.map(lineNo => (
                            <th key={lineNo} colSpan="2">
                                {t("application_strings.views.jobDiff.lineNo")} {lineNo}
                            </th>
                        ))}
                    </tr>
                    <tr>
                        <th></th>
                        {lineNumbers.map(lineNo => (
                            <React.Fragment key={lineNo}>
                                <th>{t("application_strings.views.jobDiff.originalValue")}</th>
                                <th>{t("application_strings.views.jobDiff.newValue")}</th>
                            </React.Fragment>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {allProperties.map(property => (
                        <tr key={property}>
                            <td>{getFieldName(property)}</td>
                            {lineNumbers.map(lineNo => {
                                const diff = diffs.find(d => d.LineNo === lineNo);
                                const item = diff?.Items.find(i => i.FieldName === property);
                                
                                if (!item) {
                                    return <React.Fragment key={lineNo}>
                                        <td></td>
                                        <td></td>
                                    </React.Fragment>;
                                }

                                return <React.Fragment key={lineNo}>
                                    <td className="accentNumCol">
                                        {renderValue(item.OriginalValue, item.IsCurrency, item.Type)}
                                    </td>
                                    <td className="accentNumCol">
                                        {renderValue(item.NewValue, item.IsCurrency, item.Type)}
                                    </td>
                                </React.Fragment>;
                            })}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </Col>
    );
};


export async function showProductUpgradeResult(diffs) {

    if (diffs.StatusCode) return { canceled: true };

    return await showDialog(<JobLineDiffDlg diffs={diffs} title="Upgrade Changes Review" okTitle="application_strings.application.buttons.save" />);

}


export async function showRequoteResult(diffs) {

    if (diffs.StatusCode) return {canceled : true};

    return await showDialog(<JobLineDiffDlg diffs={diffs} title="Requote Change Review" okTitle="application_strings.application.buttons.ok" noCancel />);

}

export const JobLineDiffDlg = ({ onClose, diffs, title, okTitle, noCancel }) => {
    const close = () => {
        onClose({ canceled: false });
    }

    const showProductDiffs = async (product) => {
        const productDiffs = diffs.filter(d => d.Product === product);
        await showOK(
            `${t("application_strings.views.jobDiff.details")} - ${product}`,
            <ProductDiffs diffs={productDiffs} />,
            ["application_strings.application.buttons.ok"],
            false,
            null,
            true
        );
    }

    // Group diffs by product and calculate statistics
    const productSummary = diffs.reduce((acc, diff) => {
        if (!acc[diff.Product]) {
            acc[diff.Product] = {
                totalDiffs: 0,
                lineChanges: 0,
                totalLines: 0,
                hasNonVersionChanges: false,
                diffs: []
            };
        }
        acc[diff.Product].totalDiffs += diff.Items.length; // Only count actual changes
        acc[diff.Product].lineChanges += diff.Items.length > 0 ? 1 : 0; // Count 1 if line has any changes
        acc[diff.Product].totalLines++;
        // Check if there are any changes that are not ProductVersion
        acc[diff.Product].hasNonVersionChanges = acc[diff.Product].hasNonVersionChanges || 
            diff.Items.some(item => item.FieldName !== "ProductVersion");
        acc[diff.Product].diffs.push(diff);
        return acc;
    }, {});

    // Check if there are any changes across all products
    const hasChanges = Object.values(productSummary).some(stats => stats.totalDiffs > 0);
    const allowOk = hasChanges;

    // Sort products alphabetically
    const sortedProducts = Object.entries(productSummary)
        .sort(([a], [b]) => a.localeCompare(b));

    const content = <Col md="12">
        <Table className="table-sm">
            <thead>
                <tr>
                    <th>{t("application_strings.views.jobDiff.product")}</th>
                    <th className="accentNumCol">{t("Lines")}</th>
                    <th className="accentNumCol">{t("Lines Changed")}</th>
                    <th className="accentNumCol">{t("Total Changes")}</th>
                    <th>{t("application_strings.views.jobDiff.details")}</th>
                </tr>
            </thead>
            <tbody>
                {sortedProducts.map(([product, stats]) => (
                    <tr key={product}>
                        <td>{product}</td>
                        <td className="accentNumCol text-muted">{stats.totalLines}</td>
                        <td className="accentNumCol text-muted">{stats.lineChanges}</td>
                        <td className={`accentNumCol ${stats.totalDiffs > 0 ? "text-danger" :"text-muted"}`}>{stats.totalDiffs}</td>
                        <td>
                            <AccentIcons.More onClick={() => showProductDiffs(product)} />                            
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    </Col>

    return <AccentDialog
        headerContent={t(title)}
        maxWidth={800}
        noCancel={noCancel}
        onClose={onClose}
        actionsContent={[
            <AccentButton key="2" tagName="ptCloseBtn" disabled={!allowOk} onClick={close}>
                {t(okTitle)}
            </AccentButton>
        ]}
    >
        {content}
    </AccentDialog>;
}